module.exports = __webpack_public_path__ + "static/media/C035.4d312d4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C035.jpg
// module id = 318
// module chunks = 0